import React from 'react';

import { useMediaQuery, useTheme } from '@mui/material';
import { AlineButton } from 'src/components';
import { useExportWorkflowFiles } from 'src/hooks';
import { makeStyles } from 'tss-react/mui';

import { SigningOutcomeCard, useGoToAline } from './SigningOutcomePage';

const useStyles = makeStyles()(theme => ({
  buttonContainer: {
    display: 'flex',
    gap: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%',
    },
  },
}));

export function DoneSigningBody({
  isAllDoneSigning,
  isInternalUser,
  loading,
  workflowId,
}: {
  isAllDoneSigning: boolean;
  isInternalUser: boolean;
  loading: boolean;
  workflowId: string | undefined;
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const handleGoToAline = useGoToAline(isInternalUser);

  if (loading) return <SigningOutcomeCard />;

  if (isAllDoneSigning)
    return (
      <AllDoneSigning
        handleGoToAline={handleGoToAline}
        isMobile={isMobile}
        workflowId={workflowId}
      />
    );

  return (
    <SigningOutcomeCard
      primaryText="You're done signing!"
      secondaryText="We'll notify you when all signers have signed."
    >
      <AlineButton
        color="primary"
        fullWidth={isMobile}
        variant="outlined"
        onClick={handleGoToAline}
      >
        Go to Aline
      </AlineButton>
    </SigningOutcomeCard>
  );
}

function AllDoneSigning({
  handleGoToAline,
  isMobile,
  workflowId,
}: {
  handleGoToAline: () => void;
  isMobile: boolean;
  workflowId: string | undefined;
}) {
  const { classes } = useStyles();
  const { exportToPdf, loading: exporting } = useExportWorkflowFiles(workflowId);

  return (
    <SigningOutcomeCard
      primaryText="All recipients are done signing!"
      secondaryText="Download your signed documents or head back to Aline."
    >
      <div className={classes.buttonContainer}>
        <AlineButton
          color="primary"
          fullWidth={isMobile}
          loading={exporting}
          variant="outlined"
          onClick={exportToPdf}
        >
          Download Documents
        </AlineButton>
        <AlineButton
          color="primary"
          fullWidth={isMobile}
          variant="contained"
          onClick={handleGoToAline}
        >
          Go to Aline
        </AlineButton>
      </div>
    </SigningOutcomeCard>
  );
}
